import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useAppDispatch } from 'core/store/hooks';
import { saveDashboardStoricoFilters, StoricoFiltersDto } from 'pages/private/dashboard/_redux/actions';

const useFormDashboardStorico = (initialData: any) => {
  const dispatch = useAppDispatch();
  const [chipsFormData, setChipsFormData] = useState<any[]>([]);
  const [filterParams, setFilterParams] = useState<any[]>([]);

  const { reset } = useForm({
    mode: 'onChange',
    defaultValues: initialData,
  });

  const onSubmit = (data: any) => {
    const formDataArray = [];

    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        if (data[key] !== initialData[key]) {
          formDataArray.push([key, data[key]]);
        }
      }
    }

    setFilterParams([...formDataArray]);
    setChipsFormData([...formDataArray]);

    const filtersStorico: StoricoFiltersDto = {};
    if (data.fkChiaveMisura) {
      filtersStorico.fkChiaveMisura = data.fkChiaveMisura;
    }
    if (data.dataConfronto) {
      filtersStorico.dataConfronto = data.dataConfronto;
    }

    dispatch(saveDashboardStoricoFilters(filtersStorico));
  };

  const onReset = () => {
    reset(initialData);
    setChipsFormData([]);
    setFilterParams([]);
    // Il reset riporta la data di confronto al default (oggi - 7) anche nel datepicker
    dispatch(saveDashboardStoricoFilters({ dataConfronto: initialData.dataConfronto }));
  };

  return { onSubmit, onReset, filterParams, chipsFormData, setChipsFormData, reset };
};

export default useFormDashboardStorico;
